import { DrawerHeading, DrawerListSubHeader } from "../Drawer.styled";
import {
  MENU_COLLECTION_REQUIRED,
  PAGE_COLLECTION_REQUIRED,
  PAGE_ROLE_REQUIRED,
} from "../../../constants/access";

import { DRAWER_MENU } from "../../../constants/menu";
import { Divider } from "@mui/material";
import { DrawerSectionProps } from "../../../types/DrawerSection";
import EnsureUserHasAccess from "../../../security/EnsureUserHasAccess";
import MenuItem from "../../Menu/MenuItem";
import { useTranslation } from "react-i18next";

const Sav = ({ open }: DrawerSectionProps) => {
  const { t } = useTranslation();

  return (
    <EnsureUserHasAccess
      collections={MENU_COLLECTION_REQUIRED.SAV}
      collectionStrategy="any"
      redirect={false}
    >
      <DrawerHeading sx={{ ...(open && { p: 0 }) }}>
        {open ? (
          <DrawerListSubHeader>{t("utils_label")}</DrawerListSubHeader>
        ) : null}

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.SAV_HARDWARE_VERSION}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.SAV_HARDWARE_VERSION} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.SAV_FULLY_MANAGER}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.SAV_FULLY_MANAGER} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          roles={PAGE_ROLE_REQUIRED.WIFI_CONFIG}
          roleStrategy="any"
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.WIFI_CONFIG} />
        </EnsureUserHasAccess>
      </DrawerHeading>
      {!open ? <Divider /> : null}
    </EnsureUserHasAccess>
  );
};

export default Sav;
